import VendedorService from "@/services/VendedorService";

export const vendedor = {
  namespaced: true,
  state: {
    vendedor: {},
  },
  actions: {
    getVendedor({ commit }, payload) {
      return VendedorService.GetVendedor(payload).then(
        (vendedor) => {
          return Promise.resolve(vendedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postVendedor({ commit }, payload) {
      return VendedorService.PostVendedor(payload).then(
        (vendedor) => {
          return Promise.resolve(vendedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putVendedor({ commit }, payload) {
      return VendedorService.PutVendedor(payload).then(
        (vendedor) => {
          return Promise.resolve(vendedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteVendedor({ commit }, payload) {
      return VendedorService.DeleteVendedor(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVendedorOData({ commit }, payload) {
      return VendedorService.GetVendedorOData(payload).then(
        (vendedor) => {
          return Promise.resolve(vendedor);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default vendedor;
